'use strict';

var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var exporter = require('ipfs-unixfs-exporter');

var applyDefaultOptions = require('./utils/apply-default-options');

var toMfsPath = require('./utils/to-mfs-path');

var errCode = require('err-code');

var _require = require('../../utils'),
    withTimeoutOption = _require.withTimeoutOption;

var defaultOptions = {
  offset: 0,
  length: Infinity
};

module.exports = function (context) {
  return withTimeoutOption(function mfsRead(path) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    options = applyDefaultOptions(options, defaultOptions);
    return _defineProperty({}, Symbol.asyncIterator, function () {
      var _read = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var mfsPath, result, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, buf;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _awaitAsyncGenerator(toMfsPath(context, path));

              case 2:
                mfsPath = _context.sent;
                _context.next = 5;
                return _awaitAsyncGenerator(exporter(mfsPath.mfsPath, context.ipld));

              case 5:
                result = _context.sent;

                if (!(result.unixfs.type !== 'file')) {
                  _context.next = 8;
                  break;
                }

                throw errCode(new Error("".concat(path, " was not a file")), 'ERR_NOT_FILE');

              case 8:
                if (result.content) {
                  _context.next = 10;
                  break;
                }

                throw errCode(new Error("Could not load content stream from ".concat(path)), 'ERR_NO_CONTENT');

              case 10:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context.prev = 12;
                _iterator = _asyncIterator(result.content({
                  offset: options.offset,
                  length: options.length
                }));

              case 14:
                _context.next = 16;
                return _awaitAsyncGenerator(_iterator.next());

              case 16:
                _step = _context.sent;
                _iteratorNormalCompletion = _step.done;
                _context.next = 20;
                return _awaitAsyncGenerator(_step.value);

              case 20:
                _value = _context.sent;

                if (_iteratorNormalCompletion) {
                  _context.next = 28;
                  break;
                }

                buf = _value;
                _context.next = 25;
                return buf;

              case 25:
                _iteratorNormalCompletion = true;
                _context.next = 14;
                break;

              case 28:
                _context.next = 34;
                break;

              case 30:
                _context.prev = 30;
                _context.t0 = _context["catch"](12);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 34:
                _context.prev = 34;
                _context.prev = 35;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context.next = 39;
                  break;
                }

                _context.next = 39;
                return _awaitAsyncGenerator(_iterator.return());

              case 39:
                _context.prev = 39;

                if (!_didIteratorError) {
                  _context.next = 42;
                  break;
                }

                throw _iteratorError;

              case 42:
                return _context.finish(39);

              case 43:
                return _context.finish(34);

              case 44:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[12, 30, 34, 44], [35,, 39, 43]]);
      }));

      function read() {
        return _read.apply(this, arguments);
      }

      return read;
    }());
  });
};